import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AuthTokenService } from '../auth/auth-token.service';

function checkAuth(): boolean | ReturnType<Router['createUrlTree']> {
  const token = inject(AuthTokenService).getToken();
  if (token) return true;
  return inject(Router).createUrlTree(['/auth/login']);
}

function checkGuest(): boolean | ReturnType<Router['createUrlTree']> {
  const token = inject(AuthTokenService).getToken();
  if (!token) return true;
  return inject(Router).createUrlTree(['/']);
}

export const authGuard: CanActivateFn = () => checkAuth();
export const authMatchGuard: CanMatchFn = () => checkAuth();
export const guestGuard: CanActivateFn = () => checkGuest();
